<template>
  <div id="join-widget"></div>
</template>

<script>
export default {
  name: "cms-job-widget",
  mounted() {
    var p = document.getElementById("join-widget");
    var j = document.createElement("script");
    j.type = "application/json";
    j.innerText =
      '{"accessToken":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXR0aW5ncyI6eyJzaG93Q2F0ZWdvcnlGaWx0ZXIiOnRydWUsInNob3dMb2NhdGlvbkZpbHRlciI6dHJ1ZSwic2hvd0VtcGxveW1lbnRUeXBlRmlsdGVyIjp0cnVlLCJsYW5ndWFnZSI6ImVuIiwiam9ic1BlclBhZ2UiOjI1fSwiam9icyI6e30sImRlc2lnbiI6eyJzaG93TG9nbyI6dHJ1ZSwic2hvd0xvY2F0aW9uIjp0cnVlLCJzaG93RW1wbG95bWVudFR5cGUiOnRydWUsInNob3dDYXRlZ29yeSI6dHJ1ZSwiY29sb3JzIjp7IndpZGdldCI6eyJiYWNrZ3JvdW5kIjoiI0ZGRkZGRiIsImZpbHRlckJvcmRlciI6IiNDN0NERDgiLCJwYWdpbmF0aW9uIjoiIzI1OEFGRiJ9LCJqb2JDYXJkIjp7InNoYWRvdyI6IiNDN0NkRDgiLCJiYWNrZ3JvdW5kIjoiI0ZGRkZGRiIsInByaW1hcnlUZXh0IjoiIzMwMzQ0NiIsInNlY29uZGFyeVRleHQiOiIjOEY5Q0IyIn19fSwidmVyc2lvbiI6MiwiY29tcGFueVB1YmxpY0lkIjoiNzhiNmZjODRiYzZlM2U1YjlhYzMxNGMxNDVmMWZkMmMiLCJpYXQiOjE1OTc3NjI1OTUsImp0aSI6ImRjZTRkMjExLWQ1NmItNDQ3My04NDBiLWU3YTAwNTExYjRlNiJ9.NH-CMb-0VqQHRmivGV8ztS0VgzRmUC7FMvrdF5KvaAI"}';
    p.appendChild(j);
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://cdn-widgetv2.join.com/widget.98494d6b9a246311b073172e67e8e2f95d6f8e09.js";
    p.appendChild(s);
  },
}
</script>

<style>
#join-widget>div {
  padding: 0 !important;
  background: none !important;
}
</style>
